import {
	EuiTable,
	EuiTableHeader,
	EuiTableHeaderCell,
	EuiTableBody,
	EuiTableRow,
	EuiTableRowCell,
} from '@equipmentshare/ds2'
import { Link } from 'react-router-dom'

import { OutgoingTransfer } from '../OutgoingPopover'

export type OutgoingTableProps = {
	transfers: OutgoingTransfer[],
}

export default function OutgoingTable( { transfers }: OutgoingTableProps ) {
	return (
		<EuiTable tableLayout="auto">
			<EuiTableHeader>
				<EuiTableHeaderCell>Transfer</EuiTableHeaderCell>
				<EuiTableHeaderCell>Qty</EuiTableHeaderCell>
			</EuiTableHeader>
			<EuiTableBody>
				{ transfers.map( ( transfer ) => (
					<EuiTableRow key={`outgoing-${transfer.transferOrderId}`}>
						<EuiTableRowCell>
							<Link to={`/transfer-orders/${transfer.transferOrderId}`}>TO-{transfer.transferOrderId}</Link>
						</EuiTableRowCell>
						<EuiTableRowCell>{transfer.quantity}</EuiTableRowCell>
					</EuiTableRow>
				) )}
			</EuiTableBody>
		</EuiTable>
	)
}
